import { handleRequest } from "../utilities/requestHandler";

export const getRequestListBySiteId = (siteNumber) =>
    handleRequest("post", "/request_list/bysiteid", {
        site_number: siteNumber,
    });

export const deleteFromRequestList = (selectedRows, selectedSite) =>
    handleRequest("post", "/request_list/delete", {
        selected_rows: selectedRows,
        selectedSite: selectedSite,
    });

export const notifyCustomerCare = (req_body) =>
    handleRequest("post", "/request_list/notifycc", req_body);